import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';

type PaymentRow = { date: string; customer: string; amount: number; customerId?: number | string };

interface PaymentsRowProps {
  onCustomerClick: (customerId?: number) => void;
}

const PaymentsTable: React.FC<{ title: string; rows: PaymentRow[]; onCustomerClick: (customerId?: number) => void }>=({ title, rows, onCustomerClick }) => (
  <div className="card">
    <h4 className="card-title">{title}</h4>
    <table className="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Customer</th>
          <th style={{ textAlign:'right' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.date}</td>
            <td>
              {r.customerId ? (
                <button type="button" className="dashboard-customer-link" onClick={() => onCustomerClick(Number(r.customerId))}>
                  {r.customer}
                </button>
              ) : r.customer}
            </td>
            <td style={{ textAlign:'right' }}>₹{r.amount.toLocaleString('en-IN')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const PaymentsRow: React.FC<PaymentsRowProps> = ({ onCustomerClick }) => {
  const { data } = useDashboardData();
  const [received, setReceived] = useState<PaymentRow[]>([]);
  const [pending, setPending] = useState<PaymentRow[]>([]);
  useEffect(() => {
    if (!data) return;
    const normalize = (row: any): PaymentRow => ({
      ...row,
      customerId: row.customerId ?? row.customer_id ?? row.customer?.id,
      date: new Date(row.date).toLocaleDateString(undefined, { day: '2-digit', month: 'short' }),
    });
    const rec = (data.paymentsReceived || []).map(normalize);
    const pen = (data.paymentsPending || []).map(normalize);
    setReceived(rec);
    setPending(pen);
  }, [data]);

  return (
    <>
      <PaymentsTable title="Payments Received" rows={received} onCustomerClick={onCustomerClick} />
      <PaymentsTable title="Payments Pending" rows={pending} onCustomerClick={onCustomerClick} />
    </>
  );
};

export default PaymentsRow;
